<template>
  <div class="filter__item">
    <label class="filter__item__title">
      {{ $t('autoinformer.stats.filter.status') }}
    </label>
    <div class="filter__item__body">
      <i-select :value="value" :filterable="true" :clearable="true" :transfer="true" @input="input">
        <i-option
          v-for="(label, key) in list"
          :key="key"
          :label="label"
          :value="key"
        />
      </i-select>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: [Number, String],
        default: ''
      }
    },

    computed: {
      list() {
        const obj = this.$t('autoinformer.stats.state');
        return Object.fromEntries(
          Object.entries(obj).filter(
            ([key]) => !key.includes('PROGRESS') && !key.includes('NO_ANSWER')
          )
        );
      }
    },
    methods: {
      input(val) {
        this.$emit('input', val);
      }
    }
  };
</script>
